import { render, staticRenderFns } from "./RedeemLogWrapper.vue?vue&type=template&id=a8b42890"
import script from "./RedeemLogWrapper.vue?vue&type=script&lang=js"
export * from "./RedeemLogWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports